import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import Griddle, { plugins } from 'griddle-react';
import HotelListItem from './HotelListItem';

function hasHotels(hotels) {
  if (!hotels) {
    return false;
  }
  if (Object.prototype.hasOwnProperty.call(hotels, 'length')) {
    return hotels.length !== 0;
  }
  return false;
}

const CustomTableComponent = OriginalComponent =>
  class CustomTableComponent extends React.Component {
    static contextTypes = {
      components: PropTypes.object,
    };

    render() {
      return <this.context.components.TableBody />;
    }
  };

const CustomTableBody = ({ rowIds, Row, style, className }) => (
  <div style={style} className={className}>
    {rowIds && rowIds.map(r => <Row key={r} griddleKey={r} />)}
  </div>
);
const sortProperties = [
  { id: 'selected', sortAscending: false },
  { id: 'sortOrder', sortAscending: true },
  { id: 'is_subscriber_hotel', sortAscending: false },
  { id: 'distance', sortAscending: true },
  { id: 'name', sortAscending: true },
];

class HotelList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      counter:0,
      lastSelectedHotelId: null,
      scrollValue:null,
      hotels: props.hotels || [],
    };
    this.selectHotelList = this.selectHotelList.bind(this);
    this.favHotel = this.favHotel.bind(this);
    this.sortSelectedHotels = this.sortSelectedHotels.bind(this);
  //   if(typeof(this.props.hotels != 'undefined' && this.props.hotels.length)) {
  //     this.sortSelectedHotels(this.props.hotels);
  //  }
  }
  // componentWillReceiveProps(nextProps) {
  //   if(typeof(nextProps.hotels != 'undefined' && nextProps.hotels.length)) {
  //     this.sortSelectedHotels(nextProps.hotels);
  //  }
  // }

  componentDidMount() {
    this.updateCounter(this.props.hotels);
    this.sortSelectedHotels(this.props.hotels);
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.hotels !== this.props.hotels) {
      this.sortSelectedHotels(this.props.hotels);
    }
  }
  updateCounter(hotels) {
    const count = hotels.filter(hotel => hotel.selected).length;
    this.setState({ counter: count });
  }

  sortSelectedHotels(hotels) {
    // Filter selected hotels
    const currentScrollPosition = window.scrollY;
    let selectedHotels = hotels.filter(hotel => hotel.selected);
    // Sort selected hotels by sortOrder ascending initially
    selectedHotels.sort((a, b) => a.sortOrder - b.sortOrder);

    // Identify the index of the last selected hotel
    let lastIndex = selectedHotels.findIndex(hotel => hotel.id === this.state.lastSelectedHotelId);

    // Ensure the last selected hotel is prioritized
    if (lastIndex !== -1 && lastIndex !== 0) {
      let lastSelectedHotel = selectedHotels.splice(lastIndex, 1)[0];
      selectedHotels.unshift(lastSelectedHotel);
    }

    // Assign sortOrder based on the position in the selected list
    selectedHotels.forEach((hotel, index) => {
      hotel.sortOrder = index + 1; // Assign increasing sortOrder for other selected hotels
    });
    // Update sortOrder in propsHotelsList based on sorted selectedHotels
    let updatedHotels = hotels.map(hotel => {
      const foundHotel = selectedHotels.find(selected => selected.id === hotel.id);
      if (foundHotel) {
        return { ...hotel, sortOrder: foundHotel.sortOrder };
      } else {
        return hotel;
      }
    });
    this.setState({ hotels: updatedHotels }, () => {
      window.scrollTo({
        top: currentScrollPosition,
        // behavior: 'smooth',
      });
      this.setState({
        scrollValue:null
      })
    });
  }

  selectHotelList(hotelId) {
    const currentScrollPosition = window.scrollY;
    this.setState({
      scrollValue:currentScrollPosition
    })
    if(hotelId.selected){
      this.setState({ lastSelectedHotelId: hotelId.hotel });
    }
    else{
      this.setState({ lastSelectedHotelId: null });
    }
    console.log('select hotel from list', hotelId, this.props.eventId);
    this.props.selectHotel(this.props.eventId, hotelId, (response)=>{
      this.props.requestBidsets(this.props.selectedTourId)
      if(hotelId.selected==true){
      let count = this.state.counter+1;
      this.setState({
        counter:count
      })
    }
    else{
      let count = this.state.counter-1;
      this.setState({
        counter:count
      })
    }
    });
  }
  favHotel(hotelId, fav) {
    this.props.favoriteHotel(hotelId, fav);
  }

  render() {
    const CustomRowComponent = connect((state, props) => ({
      rowData: plugins.LocalPlugin.selectors.rowDataSelector(state, props),
    }))(({ rowData }) => (
      <HotelListItem
        hotel={rowData}
        selectHotel={this.selectHotelList}
        favoriteHotel={this.favHotel}
        displayHotel={this.props.displayHotel}
        groupId={this.props.event.event.group}
        event={this.props.event}
        displayError={this.props.displayError}
      />
    ));
    if(this.props.event.needFetch){
      
      return <p className="text-center">
        <i className="fa fa-spinner fa-spin fa-3x fa-fw" />
        <span className="sr-only">Loading hotels...</span>
      </p>
    }
    if (!hasHotels(this.props.hotels)) {
      return <p>No hotels found. Please modify your search preferences.</p>;
    }
    const style = {'backgroundColor':'green'};
    return (
      <div className="add-hotel-popup-hotels-list">
        <p>Selected Hotels<span className="badge" style={style}>{this.state.counter}</span></p>
        <Griddle
          data={this.props.hotels}
          pageProperties={{
            pageSize: this.props.pageSize ? this.props.pageSize : 100,
          }}                                                 
          plugins={[plugins.LocalPlugin]}
          sortProperties={sortProperties}
          components={{
            Row: CustomRowComponent,
            TableContainer: CustomTableComponent,
            TableBody: CustomTableBody,
            SettingsToggle: () => <span />,
          }}
        />
      </div>
    );
  }
}

HotelList.propTypes = {
  hotels: PropTypes.arrayOf(PropTypes.object).isRequired,
  eventId: PropTypes.number.isRequired,
  selectHotel: PropTypes.func.isRequired,
  favoriteHotel: PropTypes.func.isRequired,
  displayHotel: PropTypes.func.isRequired,
};

HotelList.defaultProps = {
  hotels: [],
};
export default HotelList;



// WEBPACK FOOTER //
// src/routes/tours/components/HotelList.js